import { Component, OnInit } from '@angular/core';
import { AltaSolicitudesService, OptionsService, MiFielService, ReportesPDFService, FacturasService } from '../../services/service.index';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { forkJoin, Observable } from 'rxjs';
import swal2, { SweetAlertResult } from 'sweetalert2';
import { HttpClient } from '@angular/common/http';
import * as XLSX from 'xlsx';
import { retryWhen, delay, scan } from 'rxjs/operators';



@Component({
  selector: 'app-estatussolicitudes',
  templateUrl: './estatussolicitudes.component.html',
  styleUrls: ['./estatussolicitudes.component.css']
})
export class EstatusSolicitudesComponent implements OnInit {
  selectedFile: File | null = null;
  accesoupdateatta = false;
  uploadForm: FormGroup;
  url: any;
  file: any;
  datosdetalles: any[] = [];
  selectedSol: any[] = [];
  cols: any[] = [];
  solicitudes: any[] = [];
  estatussolicitudes: any[] = [];
  usuarios: any[] = [];
  idu: string;
  documentonulo: boolean;
  uploadURL: Observable<string>;
  uploadProgress: Observable<number>;
  showModal: boolean;
  showmodalds: boolean;
  idsolicitud: string;
  foliosolicitud: string;
  carpeta: string;
  nombrearchivosubido: string;
  trinitas_notifications = '';
  //NuevaTabla ///
  sortColumn: string = ''; // Columna actual de ordenación
  sortDirection: 'asc' | 'desc' = 'asc'; // Dirección de ordenación
  bancoppeldash = false;
  SolFonHisEssol: any[] = [];
  SolFonHisEsDifsol: any[] = [];
  ClienxCadena: any[] = [];
  items: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 10;
  searchTerm: string = '';
  maxVisiblePages: number = 8; // Número máximo de páginas visibles
  searchTerms = {
      folio: '',
      fecha_operacion:'',
      fecha_vencimiento:'',
      total_operar:'',
      moneda:'',
      usuario:'',
      status:'',
      cadena:'',
      proovedor:''
    };
    selectedRows = new Set<any>(); // Almacena las filas seleccionadas
    allData = []; // Todos los datos disponibles (incluidos los de otras páginas).
    /////////////

  constructor(private _formBuilder: FormBuilder,
              public router: Router,
              private route: ActivatedRoute,
              public _optionsservice: OptionsService,
              public _mifiel: MiFielService,
              public reportespdf: ReportesPDFService,
              private formBuilder: FormBuilder, private httpClient: HttpClient, 
              public _facturas: FacturasService,
              public _solicitudesservice: AltaSolicitudesService) {}

  ngOnInit() {
    swal2.fire({
      title: 'Cargando',
      allowOutsideClick: false
      });
    swal2.showLoading();
    this.uploadForm = this.formBuilder.group({
      profile: ['']
    });
    this.selectedSol = [];
    this.idu = localStorage.getItem('id');
    this.accesoupdateatta = false;
    this._solicitudesservice.getGeneralParam('TRINITAS_NOTIFICATIONS').subscribe(param => {
      if(typeof(param['value']) == 'string'){
        this.trinitas_notifications = param['value'];
      }
    })
   // forkjoin
     // Función para manejar reintentos con tiempo de espera
     const retryDelay = 2000; // 2 segundos de espera entre reintentos
     const maxRetries = 3;    // Máximo de 3 reintentos
     const retryWithDelay = () => retryWhen(errors =>
  errors.pipe(
    scan((retryCount, error) => {
      if (retryCount >= maxRetries) {
        throw error; // Lanza el error después del número máximo de reintentos
      }
      console.warn(`Reintento #${retryCount + 1} después de ${retryDelay} ms`);
      return retryCount + 1;
    }, 0),
    delay(retryDelay)
  )
);
    const observable1 = this._solicitudesservice.getSolicitudesxusuario(this.idu).pipe(retryWithDelay()) as Observable<any[]>;
    const observable2 = this._solicitudesservice.getUsuariosFinanciero().pipe(retryWithDelay()) as Observable<any[]>;
    const observable3 = this._solicitudesservice.getEstatusFacturas().pipe(retryWithDelay()) as Observable<any[]>;
   forkJoin([observable1, observable2, observable3]).subscribe(async ([res1, res2, res3]) => {
    this.solicitudes = res1;
    this.usuarios = res2;
    this.estatussolicitudes = res3;
      const estatus: any = document.getElementById('estatus');
      estatus.options[estatus.selectedIndex].value = 0;
      swal2.close();
   }, (err) => {
     console.log(err);
     swal2.close();
     swal2.fire({
       title: 'Ocurrio un error al consultar la información',
       icon: 'info',
       allowOutsideClick: false
     }). then ( res => {
       if ( res.value ) {
         this.router.navigate(['/dashboard']);
       }
     } );
   });
    
  }

  hideds() {
    this.showmodalds = false;
  }

  show(datarow: { id: string; folio: string; }) {
    this.showModal = true; // Show-Hide Modal Check
    console.log(datarow);
    this.idsolicitud = datarow.id;
    this.foliosolicitud = datarow.folio;
  }
  hide() {
    this.showModal = false;
    this.idsolicitud = '';
    this.foliosolicitud = '';
    window.location.reload();
  }

  mustradetallessolicitud(id, event) {
    event.stopPropagation(); // Detener la propagación del clic
    this.showmodalds = true;
    this._solicitudesservice.getdetallessolicitudes(id).subscribe( resp => {this.datosdetalles = resp  } 
    ,(err) => {
      swal2.fire(
        'Ocurrio un error al consultar los detalles',
        '',
        'error'
        );
    })
  }

  async guardarCambios() {
    const estatusPermitidos = [
        'PENDIENTE',
        'ESPERA FIRMA DIGITAL',
        'FIRMADO DIGITALMENTE',
        'APROBADA'
    ];
    let estatusMod = '';
    const selectedRowsArray = Array.from(this.selectedRows);
    this.selectedSol = selectedRowsArray;
    let idu = (document.getElementById('usuario') as HTMLInputElement).value;
    let estatusval: any = (document.getElementById('estatus') as HTMLInputElement).value;

    if (this.selectedSol.length === 1) {
        estatusMod = this.selectedSol[0].status.trim().toUpperCase();
    }
    if (this.selectedSol.length === 0) {
        swal2.fire('Debe seleccionar al menos una solicitud', '', 'info');
        return;
    } else if (estatusval === '0' && idu === '') {
        swal2.fire('Debe seleccionar un estatus o un usuario', '', 'info');
        return;
    } else if (estatusval === 'CANCELADA' && this.selectedSol.length > 1) {
        swal2.fire('Solo puede seleccionar una solicitud a la vez si el estatus es "CANCELADA"', '', 'info');
        return;
    } else if (estatusval === 'CANCELADA' && this.selectedSol.length === 1 && !estatusPermitidos.includes(estatusMod)) {
        swal2.fire(
            'Solo se pueden cancelar solicitudes que estén en los estatus: PENDIENTE, ESPERA FIRMA DIGITAL, FIRMADO DIGITALMENTE o APROBADA',
            '',
            'info'
        );
        return;
    }

    let params = {
        request: {}
    };

    let flag = true;
    if (estatusval === 'CANCELADA') {
        await swal2.fire({
            text: "¿Desea que las facturas vuelvan a estar disponibles para descuento?",
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
            showCloseButton: true,
            allowOutsideClick: false
        }).then((result) => {
            if (result.value) {
                params['invoices_available'] = 'true';
            } else if (result.dismiss == swal2.DismissReason.cancel) {
                params['invoices_available'] = 'false';
            } else if (result.dismiss == swal2.DismissReason.close) {
                flag = false;
            }
        });
    }

    if (!flag) return;

    const resultados = [];
    try {
      swal2.fire({
        title: 'Procesando cambios',
        text: 'Por favor, espere...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: () => {
          swal2.showLoading();
        },
      });

        for (const prop in this.selectedSol) {
            const ids = this.selectedSol[prop].id;

            if (estatusval !== '0' && idu !== '') {
                params['request']['user_id'] = idu;
                params['request']['status'] = estatusval;
            } else if (estatusval !== '0' && idu === '') {
                params['request']['status'] = estatusval;
            } else if (estatusval === '0' && idu !== '') {
                params['request']['user_id'] = idu;
            }

            try {
                const resultado = await this.updateSolicitudes(ids, { ...params });
                resultados.push({ id: ids, exito: true, resultado });
            } catch (error) {
                console.error(`Error al procesar solicitud con ID ${ids}:`, error);
                resultados.push({ id: ids, exito: false, error });
            }
            await new Promise(resolve => setTimeout(resolve, 500));
        }

        const exitosas = resultados.filter(r => r.exito).length;
        const fallidas = resultados.filter(r => !r.exito).length;

        if (fallidas > 0) {
            swal2.fire({
                title: 'Resultado',
                html: `Se procesaron correctamente ${exitosas} solicitudes.<br>Hubo errores con ${fallidas} solicitudes.`,
                icon: 'warning',
                showConfirmButton: true,
                allowOutsideClick: false
            });
        } else {
            swal2.fire({
                title: 'Modificación de Solicitudes',
                text: 'Exitosa',
                icon: 'success',
                showConfirmButton: true,
                allowOutsideClick: false
            }).then(res => {
                if (res.value) {
                    location.reload();
                }
            });
        }
    } catch (error) {
        console.error('Error al procesar las solicitudes:', error);
        swal2.fire(
            'Error',
            'Hubo un problema al modificar las solicitudes. Por favor, inténtelo nuevamente.',
            'error'
        );
    }
}

  async updateSolicitudes(ids, params){
    if(params['request']['status'] == 'CANCELADA' && this.trinitas_notifications == 'SI'){
      // Bucle para seguir pidiendo la razón hasta que el usuario ingrese algo
      let result: SweetAlertResult;
      do {
        // Mostrar el modal de entrada
        result = await swal2.fire({
          title: "Teclea el motivo de la cancelación",
          input: "text",
          showCancelButton: false,
          confirmButtonText: "Enviar",
          allowOutsideClick: () => !swal2.isLoading(),
        });
      
        // Si el valor está vacío o no existe, muestra un mensaje de advertencia
        if (!result.value) {
          await swal2.fire({
            title: "Atención",
            text: 'Debe teclear una razón para la cancelación',
            icon: 'info',
            confirmButtonText: 'OK'
          });
        }
      } while (!result.value);
      swal2.showLoading();
      // Después de que el usuario ingresa algo, asignar el valora los parama
      params['request']['flow_comments'] = result.value;
    }
    return this._solicitudesservice.updateSolicitudes(ids, params).toPromise(); // Convertir observable a promesa
   //await new Promise((resolve) => setTimeout(resolve, 3000)); //linea para pruebas
   
  }

  actualizaattach() {

    if (this.selectedSol.length < 1) {
      swal2.fire(
        'Debe seleccionar al menos una solicitud',
        '',
        'error'
        );
    } else {
      // tslint:disable-next-line: forin
      for (const prop in this.selectedSol) {

        const ids = this.selectedSol[prop].id;

        const params = {
          attached: this.selectedSol[prop].attached
      };

        this._solicitudesservice.updateSolicitudes(ids, params).subscribe( );
      }
      // location.reload();
      swal2.fire({
        title: 'Los documentos seleccionados se actualizaron',
        text: 'Con exito',
        icon: 'success',
        showConfirmButton: true,
        showCancelButton: false,
        allowOutsideClick: false
      }). then ( res => {

        if ( res.value ) {
          window.location.reload();
        }

      } );
    }
  }

  subirdoc(event: any) {
    const file: File = event.target.files[0];

    if (!file) {
        swal2.fire('Error', 'No seleccionaste un archivo.', 'error');
        return;
    }

    this.selectedFile = file;
    console.log('Archivo seleccionado:', this.selectedFile);
}

async uploadFile() {
  swal2.showLoading();
  const params = {
    attached: ''
};
  if (!this.selectedFile) {
      swal2.fire('Error', 'No hay archivo seleccionado.', 'error');
      return;
  }

  try {
    // Subir archivo usando fundersUpload en lugar de Firebase
    const response = await this._facturas.fundersUpload(this.selectedFile, this.selectedFile.name);
    // Extraer la URL devuelta en la respuesta simulada
    const resp: string = (response && response.url) ? response.url : "";

    // Actualizar solicitud con la URL
    params.attached = resp;
    this._solicitudesservice.updateSolicitudes(this.idsolicitud, params).subscribe( () => { 
      swal2.fire({
      title: 'El archivo se guardo',
      text: 'Con exito',
      icon: 'success',
      showConfirmButton: true,
      showCancelButton: false,
      allowOutsideClick: false
    }). then ( res => {

      if ( res.value ) {
        window.location.reload();
      }

    } ); }, (err) => {
      console.log(err);
      swal2.fire({
        title: 'Ocurrio un error',
        text: err.error.errors[0],
        icon: 'error',
        showConfirmButton: true,
        showCancelButton: false,
        allowOutsideClick: false
      }). then ( res => {
        if ( res.value ) {
          window.location.reload();
        }
      } );
     } );


} catch (error) {
    console.error('Error en el proceso:', error);
    swal2.fire({
      title: 'Hubo un problema al subir el archivo',
      text: '',
      icon: 'success',
      showConfirmButton: true,
      showCancelButton: false,
      allowOutsideClick: false
    }). then ( res => {

      if ( res.value ) {
        window.location.reload();
      }
    } )
}

}


  borraArchivo(rowData) {

    swal2.fire({
      title: 'Desea borrar el archivo?',
        text: rowData.folio,
        icon: 'question',
        showConfirmButton: true,
        showCancelButton: true,
        allowOutsideClick: false
    }). then ( res => {
      if ( res.value ) {
        const params = {
          attached: ''
      };
    
        params.attached = null;
        this._solicitudesservice.updateSolicitudes(rowData.id, params).subscribe( () => { swal2.fire({
            title: 'El archivo se borro',
            text: 'Con exito',
            icon: 'success',
            showConfirmButton: true,
            showCancelButton: false,
            allowOutsideClick: false
          }). then ( res => {
      
            if ( res.value ) {
              window.location.reload();
            }
      
          } ); }, (err) => {
            console.log(err);
            swal2.fire({
              title: 'Ocurrio un error',
              text: err.error.errors[0],
              icon: 'error',
              showConfirmButton: true,
              showCancelButton: false,
              allowOutsideClick: false
            }). then ( res => {
              if ( res.value ) {
                location.reload();
              }
            } );
           } );
      }
    });

  }


//Nueva tabla//
pgone() {
  this.currentPage = 1;
}

get filteredDataq(): any[] {
  const filtered = this.solicitudes.filter(item => //return
    (!this.searchTerms.folio || (item.folio && item.folio.toLowerCase().includes(this.searchTerms.folio.toLowerCase()))) &&
    (!this.searchTerms.fecha_operacion || (item.fecha_operacion && item.fecha_operacion.toLowerCase().includes(this.searchTerms.fecha_operacion.toLowerCase()))) &&
    (!this.searchTerms.fecha_vencimiento || (item.fecha_vencimiento && item.fecha_vencimiento.toLowerCase().includes(this.searchTerms.fecha_vencimiento.toLowerCase()))) &&
    (!this.searchTerms.total_operar || (item.total_operar && item.total_operar.toLowerCase().includes(this.searchTerms.total_operar.toLowerCase()))) &&
    (!this.searchTerms.moneda || (item.moneda && item.moneda.toString().toLowerCase().includes(this.searchTerms.moneda.toLowerCase()))) &&
    (!this.searchTerms.usuario || (item.usuario && item.usuario.toString().toLowerCase().includes(this.searchTerms.usuario.toLowerCase()))) &&
    (!this.searchTerms.status || (item.status && item.status.toString().toLowerCase().includes(this.searchTerms.status.toLowerCase()))) &&
    (!this.searchTerms.cadena || (item.cadena && item.cadena.toString().toLowerCase().includes(this.searchTerms.cadena.toLowerCase()))) &&
    (!this.searchTerms.proovedor || (item.proovedor && item.proovedor.toString().toLowerCase().includes(this.searchTerms.proovedor.toLowerCase())))
  );
  return filtered.sort((a, b) => this.compare(a, b, this.sortColumn, this.sortDirection));
}

get dataToShow(): any[] {
  const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  return this.filteredDataq.slice(startIndex, startIndex + this.itemsPerPage);
}

get totalPages(): number {
  return Math.ceil(this.filteredDataq.length / this.itemsPerPage);
}

get pages(): number[] {
  const totalPages = this.totalPages;

  if (totalPages <= this.maxVisiblePages) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const pages = [];
  const halfRange = Math.floor(this.maxVisiblePages / 2);

  let startPage = Math.max(1, this.currentPage - halfRange);
  let endPage = Math.min(totalPages, startPage + this.maxVisiblePages - 1);

  if (endPage === totalPages) {
    startPage = totalPages - this.maxVisiblePages + 1;
  }
  if (startPage === 1) {
    endPage = this.maxVisiblePages;
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return pages;
}

// Métodos de navegación
goToPage(page: number): void {
  if (page >= 1 && page <= this.totalPages) {
    this.currentPage = page;
  }
}

previousPage(): void {
  if (this.currentPage > 1) {
    this.currentPage--;
  }
}

nextPage(): void {
  if (this.currentPage < this.totalPages) {
    this.currentPage++;
  }
}

goToEllipsisPage(position: 'first' | 'last'): void {
  if (position === 'first') {
    this.currentPage = 1;
  } else if (position === 'last') {
    this.currentPage = this.totalPages;
  }
}

exportExcelFil(tab: string) {
  let fullData: any[]
  fullData = this.filteredDataq;
  const readOpts = {
      cellText: false, 
      cellDates: true,
  };
 // Generar los datos personalizados para exportación
 const dataToExport = fullData.map(item => ({
  'Folio': item.folio || '',
  'Fecha de operacion': item.fecha_operacion || '',
  'Fecha de vencimiento': item.fecha_vencimiento || '',
  'Total operado': item.total_operar || '',
  'Moneda': item.moneda || '',
  'Usuario': item.usuario || '',
  'Estatus': item.status || '',
  'Empresa': item.cadena || '',
  'Proveedor': item.proovedor || '',
  'Cesion': item.attached || '',
  'Firma': item.extra1 || ''
}));
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport, readOpts);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, 'solicitudes.xlsx', readOpts);
}

 formatFecha(fecha: { split: (arg0: string) => [any, any, any]; }) {
  if (!fecha) return '';
  const [year, month, day] = fecha.split('-');
  return `${day}/${month}/${year}`;
}

removeCommas(monto: { toString: () => string; }) {
  if (!monto) return '';
  return monto.toString().replace(/,/g, ''); // Elimina todas las comas
}

/*reporfac(idsf: any) {
  this.fundersService.getfundingrequest(idsf).subscribe(resp => {
    this.datosdetalles = resp['data'].relations.funding_request_invoices;
    this.showmodalds = true;
  })
}

hideds() {
  this.showmodalds = false;
}*/

exportExcelcxc() {
  let fileName = 'Data.xlsx';
  /* table id is passed over here */
  const element = document.getElementById('CXC');
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  /* save to file */
  XLSX.writeFile(wb, fileName);
}

sortData(column: string): void {
  // Cambia la dirección de ordenación si se selecciona la misma columna, de lo contrario reinicia a ascendente
  if (this.sortColumn === column) {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  } else {
    this.sortColumn = column;
    this.sortDirection = 'asc';
  }
}

private compare(a: any, b: any, column: string, direction: 'asc' | 'desc'): number {
  if (!column) return 0;

  let valueA = a[column];
  let valueB = b[column];

  // Lógica personalizada para la columna de íconos
  if (column === 'statusIcon') {
    valueA = a.status === 'ESPERA FIRMA DIGITAL' ? 0 : 1; // Prioridad para mdi-close-circle
    valueB = b.status === 'ESPERA FIRMA DIGITAL' ? 0 : 1;
  }

  let comparison = 0;
  if (valueA > valueB) {
    comparison = 1;
  } else if (valueA < valueB) {
    comparison = -1;
  }

  return direction === 'asc' ? comparison : -comparison;
}

//seleccionar filas//
toggleRowSelection(row: any): void {
  if (this.selectedRows.has(row)) {
    this.selectedRows.delete(row);
  } else {
    this.selectedRows.add(row);
  }
}

// Devuelve true si la fila está seleccionada.
isRowSelected(row: any): boolean {
  return this.selectedRows.has(row);
}

// Selecciona todas las filas.

selectAllRows(): void {
  if (this.selectedRows.size === this.filteredDataq.length) {
    // Si ya están todos seleccionados, desmarcarlos
    this.selectedRows.clear();
  } else {
    // Si no, seleccionar todos
    this.allData = this.filteredDataq; // Sincronizar los datos
    this.allData.forEach(row => this.selectedRows.add(row));
  }
}

// Procesa las filas seleccionadas.
processSelectedRows(): void {
  const selectedRowsArray = Array.from(this.selectedRows);
  console.log('Filas seleccionadas:', selectedRowsArray);
}

get isAllSelected(): boolean {
  return this.selectedRows.size === this.filteredDataq.length;
}
/////////////////////////////
}







